import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { FaProjectDiagram } from 'react-icons/fa'

const projects = [
  {
    title: 'Persivia (EHR System)',
    role: 'Senior Team Member',
    description:
      'Developed a web-based Electronic Health Records (EHR) system for medical organizations, enabling patient tracking and management.',
    detailsLink: 'https://persivia.com/',
  },
  {
    title: 'SureTec (Insurance Bonding)',
    role: 'Senior Team Member',
    description:
      'Built a web application for SureTec, facilitating the purchase of bonds for principals and surety management.',
    detailsLink: 'https://www.markel.com/us/surety',
  },
  {
    title: 'EVAC (East Valley Access Center)',
    role: 'Team Lead',
    description:
      'Led development of a web application to track patient information, medications, medical reports, and appointments, utilizing Telerik controls for reporting and data visualization.',
    detailsLink: 'https://meditaz.com/index.aspx',
  },
  {
    title: 'BI (Business Intelligence)',
    role: 'Team Member',
    description:
      'Contributed to an online order management system for Nestlé distributors, integrating Telerik controls for reporting and data visualization.',
    detailsLink: '/projects/bi',
  },
  {
    title: 'SalePoint (Retail POS System)',
    role: 'Team Member',
    description:
      'Developed a desktop application for a retail store, enabling barcode scanning and order billing.',
    detailsLink: '/projects/salepoint',
  },
  {
    title: 'SchoolProject (School Management System)',
    role: 'Team Member',
    description:
      'Worked on an online system to manage student grades, assignments, and attendance, using Infragistics controls and ActiveReports for data visualization and reporting.',
    detailsLink: '/projects/schoolproject',
  },
  {
    title: 'WIMS (Workshop Information Management System)',
    role: 'Group Leader',
    description:
      'Led development of a Windows app to manage orders and tasks in an automotive workshop.',
    detailsLink: '/projects/wims',
  },
  {
    title: 'Spinning Calculations',
    role: 'Group Leader',
    description:
      'Developed a Windows app for calculating thread credentials in the spinning industry.',
    detailsLink: '/projects/spinning-calculations',
  },
  {
    title: 'Construction Management System',
    role: 'Group Leader',
    description:
      'Led the development of a web application to manage inventory for a construction company.',
    detailsLink: '/projects/construction-management',
  },
]

export default function Projects() {
  useEffect(() => {
    AOS.init({ duration: 1000 })
  }, [])

  return (
    <section id="projects" className="py-24 px-6 sm:px-12 lg:px-20">
      <h2 className="text-lg leading-7">My Work</h2>
      <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl">
        Projects
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {projects.map((project, index) => (
          <div
            key={index}
            className="group relative bg-base-200 ring-2 ring-base-300 rounded-2xl shadow-lg p-6 transition-transform transform hover:scale-105"
            data-aos="fade-up"
          >
            <div className="absolute top-4 right-4">
              <a
                href={project.detailsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-500 hover:underline"
              >
                Details
              </a>
            </div>
            <FaProjectDiagram className="text-4xl text-gray-400 dark:text-gray-600" />
            <h3 className="mt-4 text-2xl font-bold text-base-content">
              {project.title}
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 font-semibold">
              {project.role}
            </p>
            <p className="mt-2 text-base text-base-content">
              {project.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}
